import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notifyError } from "../../redux/actions/notification.actions";
import { State } from "../../redux/reducers";
import { TreeContext } from "../contexts/organizeTreeBibleContexts";
import { defaultQuery } from "../models/Query";
import { TreeModel } from "../models/TreeModels";
import {
  addNodeIdIntoDocumentUnit,
} from "../pages/organizeTree/tree/tree.utils";
import { query } from "../utils/query";

export enum SaveType {
  ADMIN,
  ORGANIZE,
}

export const useHandleSaveTree = () => {
  const [tree, setTree] = useContext(TreeContext);
  const token = useSelector(({ auth }: State) => auth.token);
  const dispatch = useDispatch();

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  return async (saveType: SaveType = SaveType.ORGANIZE) => {
    const url =
      saveType === SaveType.ORGANIZE
        ? `/api/kyrielle/tree/${tree.data?.id}/save`
        : `/api/kyrielle/tree/${tree.data?.id}/admin/save`;

    let localResult = { ...defaultQuery } as typeof tree;

    const data = await query<TreeModel>({
      url,
      method: "post",
      headers,
      setter: (update) => {
        localResult = typeof update === "function" ? update(localResult) : update;
        setTree(update);
      },
      body: tree.data,
      mapper: addNodeIdIntoDocumentUnit,
    });

    if (localResult.statusCode === 409) {
      dispatch(notifyError("KYRIELLE_SAVE_CONFLICT", {}));
    }

    return data;
  };
};

export const useGetTree = () => {
  const [tree, setTree] = useContext(TreeContext);
  const token = useSelector(({ auth }: State) => auth.token);

  // Set up the headers for the fetch request
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  return async (id: string): Promise<TreeModel> => {
    const data = (await query<TreeModel>({
      url: `/api/kyrielle/tree/${id}`,
      method: "get",
      headers,
      setter: setTree,
      body: tree.data,
      mapper: addNodeIdIntoDocumentUnit,
    })) as TreeModel;

    return data;
  };
};